import {Page} from 'Core/models/Page';
import {map as mapEither} from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import {get} from 'Shared/utilities/fetchHelpers';

export type PageFetchActionBase = {
  existingPage: Page<any>;
};

export const removeApiPrefix = (link: string) => link.replace('api/v1/', '');

export const getNextPage = <T>(page: Page<T>) =>
  page.links.filter(link => link.rel === 'nextpage')[0].href.replace('api/v1/', '');

export const mergeWithNextPage = <TData>(pageFetchAction: PageFetchActionBase) =>
  get<Page<TData>>(getNextPage(pageFetchAction.existingPage)).then(pageEither =>
    pipe(
      pageEither,
      mapEither(page => {
        return {
          currentPageNumber: page.currentPageNumber - 1,
          links: page.links,
          result: [...pageFetchAction.existingPage.result, ...page.result],
          totalCount: page.totalCount,
        } as Page<TData>;
      })
    )
  );
